import React from 'react'
import { Bleed, Card, LayoutBand, Row, Separator, H2 } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { conferenceConfig } from '@fs/zion-rootstech'
import CountDown from './CountDown'
import { countdownTimerRegistrationBackgroundJpg } from '../../images'
import { FLAGS } from '../../config'
import { useIsMdWidth } from '../../hooks'
import ResponsiveLayoutBand from '../ResponsiveLayoutBand'
import { useFlagsContext } from '../../providers'

const CountDownBanner = ({
  showWithSiteExperienceFlag = 'countdown',
  countdownImageBackground = countdownTimerRegistrationBackgroundJpg,
}) => {
  const [t] = useTranslation()
  const { [FLAGS.SITE_EXPERIENCE]: siteExperienceFlag } = useFlagsContext()
  const isMdWidth = useIsMdWidth()

  if (siteExperienceFlag.treatment !== showWithSiteExperienceFlag) return null

  return (
    <ResponsiveLayoutBand>
      <Card backgroundImage={countdownImageBackground}>
        <Bleed sides>
          <LayoutBand>
            <Separator size="md" />
            <Row alignX="center" alignY="top" wrap>
              <H2 supplementary centered={isMdWidth} data-testid="countdown-banner-heading">
                {t('homepage.countdown.begins', 'Conference Begins:')}
              </H2>
              <CountDown startTimestamp={conferenceConfig.startTimestamp} noReload />
            </Row>
            <Separator />
          </LayoutBand>
        </Bleed>
      </Card>
    </ResponsiveLayoutBand>
  )
}

export default CountDownBanner
